<!-- <br>

<div class="container-fluid align-middle">
    
    <div class="jumbotron text-center" style="color:green">
        We are verifying your identity. Please Wait... <em class="fa fa-spinner fa-pulse fa-3x fa-fw"></em>
    </div>
</div>
<div class="page-container">
    <ng-template #terms></ng-template>
</div> -->


<div class="oauth-wrapper">
    <div class="oauth-background"></div>
    <div class="oauth-container">
        <div class="oauth-content-box" *ngIf="showOAuthContent">
            <div class="oauth-inner-content">
                <img class="oauth-logo" src="../../../../assets/eliwell_se.svg" />
                <div class="spinner"></div>
                <!-- <div class="qds-controls qds-related">
                      <qds-loader size="jumbo" importance="standard"></qds-loader>
                </div> -->
                <div class="oauth-text-section">
                    <div class="oauth-text-wrapper">
                        <div class="oauth-text-content">
                           <span>We are verifying your identity. Please Wait...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="page-container">
    <ng-template #terms></ng-template>
</div>